module.exports = __webpack_public_path__ + "img/facebook-share.982bc9f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/facebook-share.svg
// module id = V6lh
// module chunks = 13